
'use strict';

module Patersons {

    export class PDFBuilderService {
        q: ng.IQService;
        userCompanyService: UserCompanyService;
        base64logo: string;
        static $inject = ['$q', 'userCompanyService'];

        constructor($q, userCompanyService) {
            this.q = $q;
            this.userCompanyService = userCompanyService
        }
        private toDataUrl(url, callback) {
          try {
            var xhr = new XMLHttpRequest();
            xhr.onload = function() {
                var reader = new FileReader();
                reader.onloadend = function() {
                    callback(reader.result);
                }
                reader.readAsDataURL(xhr.response);
            };
            xhr.open('GET', url);
            xhr.responseType = 'blob';
            xhr.send();
          } catch (error) {
            callback(null)
          }
        }
        newPdfBuilderInstance(): ng.IPromise<PdfBuilder> {
          var deferred = this.q.defer<PdfBuilder>();
          this.userCompanyService.getUserCompany().then((company) => {
            if(!this.base64logo){
              this.toDataUrl(company.companyPdfImage,(image) => {
                if(image){
                  this.base64logo = image;
                }else{
                  console.error("Could not get logo")
                }
                let pdfBuilder = new PdfBuilder(this.base64logo, company);
                deferred.resolve(pdfBuilder);
              })
            }else{
              let pdfBuilder = new PdfBuilder(this.base64logo, company);
              deferred.resolve(pdfBuilder);

            }
          })
          return deferred.promise;
        };
    }
}